import React, { useState } from 'react';
import styles from './AgentHeader.module.scss';
import { useBrandingContext } from 'app-context/BrandingsContext';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
const AgentHeader = ({
  title,
  subTitle,
  subtitleSvg,
  renderComponent,
  svgType,
  titleStyle,
}) => {
  const { brandingData } = useBrandingContext();
  const { page_TextColor, page_FontStyle, sideBar_PrimaryColor } = brandingData;

  return (
    <div
      className={`${styles['header-container']}`}
      style={{ color: page_TextColor, fontStyle: page_FontStyle }}
    >
      <div className={styles['subcontainer']}>
        <div className={styles['title-container']}>
          <p
            style={{ color: sideBar_PrimaryColor }}
            className={`${styles['title']} ${titleStyle}`}
          >
            {title}
            {/* {svgType ? <SvgWithBranding type={svgType} /> : null} */}
          </p>
          {subTitle ? (
            <div
              style={{ color: sideBar_PrimaryColor }}
              className={styles['subtitle']}
            >
              {subtitleSvg && (
                <SvgWithBranding
                  type={subtitleSvg}
                  className={`${styles['icon']}`}
                  color="#898888"
                />
              )}
              <p>{subTitle}</p>
            </div>
          ) : null}
        </div>
      </div>
      {renderComponent}
    </div>
  );
};

export default AgentHeader;
